import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
// Import React FilePond
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import { registerPlugin } from "react-filepond";

// Import the plugin code
import { Cross2Icon } from "@radix-ui/react-icons";
import FilePondPluginImageResize from "filepond-plugin-image-resize";
import { ActivationEnLigne } from "../../components/Ajouter-intention/ActivationEnLigne";
import { CollectePaiement } from "../../components/Ajouter-intention/CollectePaiement";
import { DemandeIntention } from "../../components/Ajouter-intention/DemandeIntention";
import { Eligibilite } from "../../components/Ajouter-intention/Eligibilite";
import { IndentificationClient } from "../../components/Ajouter-intention/IndentificationClient";
import { LivraisonForm } from "../../components/Ajouter-intention/Livraison";
import { PriseRendezVous } from "../../components/Ajouter-intention/PriseRendezVous";
import { PriseRendezVousRaccordement } from "../../components/Ajouter-intention/PriseRendezVousRaccordement";
import { Souscription } from "../../components/Ajouter-intention/Souscription";
import { SouscriptionTest } from "../../components/Ajouter-intention/SouscriptionTest";
import { ValidationRaccordement } from "../../components/Ajouter-intention/ValidationRaccordement";
import { ValidationSurvey } from "../../components/Ajouter-intention/ValidationSurvey";
// Register the plugins
registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginImageResize
);
// eslint-disable-next-line import/first
// eslint-disable-next-line import/first
// eslint-disable-next-line import/first

const steps = [
  "Verification d'éligilité",
  "Enregistrer une intention",
  "Collecte de paiement",
  "Livraison de l équipement",
  "Identification du client",
  "Rendez-vous de survey",
  "Survey",
  "Activation en ligne",
  "Rendez-vous de raccordement",
  "Raccordement",
  "Souscription forfait",
  "Test de connctivité"
];

const AddIntention = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set());
  const numeroTicket = localStorage.getItem("numero")
  const location = useLocation()

  console.log(location.pathname);
  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  useEffect(() => {
    localStorage.removeItem('numero')
  }, [location])
  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  return (
    <div className="font-mtn pb-32 mb-20">
      <dialog id="delete_batiment" className="modal">
        <div className="modal-box max-w-md rounded-lg">
          <h3 className="font-extrabold text-xl text-red-600 ">
            Attention
          </h3>
          <p className="pt-2 text-black font-medium">
            Voulez vous des modifications en cours ?
          </p>
          <div className="modal-action">
            <form
              method="dialog"
              className="w-full flex items-center justify-end gap-x-4"
            >
            </form>
          </div>
        </div>
      </dialog>
      <button
        onClick={() => {
          window.history.back()
          localStorage.removeItem('numero')
        }}
        className=" flex lg:hidden md:hidden xl:hidden bg-[#FF1D23]  md:mt-2 lg:mt-2 xl:mt-2 px-2 py-1 text-white rounded-lg"
      >
        Quitter le Processus
      </button>
      <h1 className="lg:text-3xl md:text-3xl xl:text-3xl text-2xl font-extrabold text-black mb-5">
        Processus d'acquisition de la FTTH
      </h1>
      <div className="py-2 h-fit flex xl:flex-row lg:flex-row md:flex-row flex-col gap-8 lg:px-8 w-full mx-auto  ">
        <div className="md:w-[20%]  lg:w-[20%]  xl:w-[20%] lg:h-[77.5vh] md:h-[77.5vh] xl:lg:h-[77.5vh] h- w-full flex flex-col justify-between pb-1">
          <div className="hidden md:block lg:block xl:block">
            <Stepper
              orientation="vertical"
              activeStep={activeStep}
              style={{ height: "20%" }}
            >
              {steps.map((label, index) => {
                const stepProps = {};
                const labelProps = {};

                if (isStepSkipped(index)) {
                  stepProps.completed = false;
                }
                return (
                  <Step key={label} {...stepProps}
                    sx={{
                      "& .MuiStepLabel-root .Mui-completed": {
                        color: "green"
                      },
                      "& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel": {
                        color: "blue"
                      },
                      "& .MuiStepLabel-root .Mui-active": {
                        color: "black"
                      },
                      "& .MuiStepLabel-root .Mui-active .MuiStepIcon-text": {
                        fill: "#ffff"
                      }
                    }}>
                    <StepLabel {...labelProps}>
                      <h2 className="text-xs font-medium">{label}</h2>
                    </StepLabel>
                  </Step>
                );
              })}
            </Stepper>
          </div>
          <div className="overflow-x-auto bg-slate-100  py-3 rounded mx-1 md:hidden lg:hidden xl:hidden">
            <Stepper
              orientation="horizontal"
              style={{ height: "100%", width: "300px" }}
              activeStep={activeStep}
            >
              {steps.map((label, index) => {
                const stepProps = {};
                const labelProps = {};

                if (isStepSkipped(index)) {
                  stepProps.completed = false;
                }
                return (
                  <Step key={label} {...stepProps}
                    sx={{
                      "& .MuiStepLabel-root .Mui-completed": {
                        color: "green"
                      },
                      "& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel": {
                        color: "blue"
                      },
                      "& .MuiStepLabel-root .Mui-active": {
                        color: "black"
                      },
                      "& .MuiStepLabel-root .Mui-active .MuiStepIcon-text": {
                        fill: "#ffff"
                      }
                    }}
                  >
                    <StepLabel {...labelProps}></StepLabel>
                  </Step>
                );
              })}
            </Stepper>
          </div>

        </div>

        <div className="bg-white py-2 px-6 pb-8 shadow rounded-lg flex flex-col w-full">
          <button
            onClick={() => {
              window.history.back()
              localStorage.removeItem('numero')
            }}
            className="ml-auto hidden lg:block md:block xl:block bg-[#FF1D23] btn btn-sm w-fit text-white hover:text-black"
          >
            <Cross2Icon />
          </button>
          <h2 className=" font-semibold text-lg">
            {
              activeStep === 0 ?
                "Vérification d'éligibilité"
                : activeStep === 1 ?
                  "Enregistrer une intention"
                  : activeStep === 2 ?
                    "Collecte de paiement"
                    : activeStep === 3 ?
                      "Livraison de l équipement"
                      : activeStep === 4 ?
                        "Identification du client"
                        : activeStep === 5 ? "Rendez-vous de survey"
                          : activeStep === 6 ? "Survey"
                            : activeStep === 7 ? "Activation en ligne"
                              : activeStep === 8 ? "Rendez-vous de raccordement"
                                : activeStep === 9 ? "Raccordement"
                                  : activeStep === 10 ? "Souscription au forfait"
                                    : "Test de connectivité"
            }
          </h2>
          {
            activeStep === 0 ?
              <Eligibilite handleNext={handleNext} />
              : activeStep === 1 ?
                <DemandeIntention handleNext={handleNext} numero={numeroTicket} />
                : activeStep === 2 ?
                  <CollectePaiement numeroTicket={numeroTicket} handleNext={handleNext} />
                  : activeStep === 3 ? <LivraisonForm numeroTicket={numeroTicket} handleNext={handleNext} />
                    : activeStep === 4 ?
                      <IndentificationClient numeroTicket={numeroTicket} handleNext={handleNext} />
                      : activeStep === 5 ? <PriseRendezVous numeroTicket={numeroTicket} />
                        : activeStep === 6 ? <ValidationSurvey numeroTicket={numeroTicket} />
                          : activeStep === 7 ? <ActivationEnLigne numeroTicket={numeroTicket} />
                            : activeStep === 8 ? <PriseRendezVousRaccordement numeroTicket={numeroTicket} />
                              : activeStep === 9 ? <ValidationRaccordement numeroTicket={numeroTicket} handleNext={handleNext} />
                                : activeStep === 10 ? <Souscription numeroTicket={numeroTicket} handleNext={handleNext} />
                                  : <SouscriptionTest numeroTicket={numeroTicket} />
          }
        </div>

      </div>


    </div>
  );
};

export default AddIntention;
